import React, { useEffect, useState } from "react";
import { connect } from "react-redux";
import CommonIcon from "../helpers/icons";
import Actions from "../../action/api"
import API from "../helpers/endpointservice";
function Unauthorize(props) { 
  useState(()=>{
    // props.dispatch({type:"BG_LOADER",data:false})
    let userName = localStorage.getItem('userNameTAC');
    let values =  Actions.logoutRedirect(`${API.GET_LOGOUT}?email=${userName}`)
    localStorage.setItem("redirectURLTAC", values.data);
    props.dispatch({type:"BG_LOADER",data:false})
  })
    
    return (
        
        <div className='mainunauthorize'>
        <div>
            
            
            <div className='submain1' style={{ width: '100vw', height: '100vh', display: 'flex', alignItems: 'center', justifyContent: 'center' }}>
                    <div className='form ' style={{ height: '400px', width: '600px',marginTop:'-100px' ,textAlign:'center'}}>
                      <CommonIcon fileName={'removeuser'}/>
                       <h3 style={{fontSize:'25px'}} className="mt-3">You don't have access to this application</h3>
                       <span>Please check with your admin</span>   
                       <div className='mt-4' >
                       <button onClick={()=>{props.handleLogout();}} className="btn-fun123">Switch user</button>
                        </div>
                    </div>
                    
                </div>
        </div>
    </div>
    );
}

const mapStateToProps = state => {
    return {
      ShowSideBar: state.SideBarReducer.ShowSideBar,
      menuToggle: state.SideBarReducer.menuToggle,
      isLogin: state.loginReducer.isLogin,
      BG_LOADER:state.userReducer.BG_LOADER,
    }
  }
  
  const mapDispatchToProps = dispatch => {
    return {
      
      dispatch
    };
  };
  
  export default connect(mapStateToProps, mapDispatchToProps)(Unauthorize);
